const packageFile = require("../../package.json");

const APP_IDENTIFIER = `${packageFile.name.toUpperCase()}_`;
export const scryptx = {
  removeItem: (itemKey) => localStorage.removeItem(APP_IDENTIFIER + itemKey),
  clear: () => localStorage.clear(),
  length: localStorage.length,
  key: localStorage.key,
  getItem: (itemKey) => localStorage.getItem(APP_IDENTIFIER + itemKey),
  setItem: (itemKey, itemValue) =>
    localStorage.setItem(APP_IDENTIFIER + itemKey, itemValue),
  setObject: (itemKey, value) => {
    try {
      return scryptx.setItem(itemKey, JSON.stringify(value));
    } catch (e) {
      console.log(e);
    }
  },
  getObject: (itemKey) => JSON.parse(scryptx.getItem(itemKey)),
};
